import React, { Fragment } from 'react'

const About = () => {
    return (
        <Fragment>
         <h1>About page</h1>
         <p>This is to find anyone in github</p>
         <p>Version 1.0.0</p>
        </Fragment>
    )
}

export default About;